import {Directive, OnDestroy} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {Subscription} from 'rxjs';
import {DialogBase} from './dialog-base';
import {FormDialogData} from './types';

@Directive()
// tslint:disable-next-line:directive-class-suffix
/**
 * 폼 대화상자 컴포넌트 기반
 */
export abstract class FormDialogBase extends DialogBase implements OnDestroy {
	protected _closeSubscription!: Subscription;
	protected _controlsPresenter: any;
	protected _submitted!: boolean;

	protected constructor(
		dialogRef: MatDialogRef<any>,
		public data: FormDialogData
	) {
		super(dialogRef);
		this.setData(data);
	}

	protected setData(data: FormDialogData) {
		this.data = data;

		if (!data) {
			return;
		}

		const {onCancel} = data;

		if (onCancel) {
			this._closeSubscription = this.dialogRef.beforeClosed()
				.subscribe(() => {
					console.log('after closed', 'submitted', this._submitted);
					if (this._submitted) {
						this._submitted = false;
					} else {
						if (typeof onCancel['cancel'] === 'function') {
							data.onCancel['cancel']();
						} else {
							(data.onCancel as Function)();
						}
					}
				});
		}
	}

	ngOnDestroy() {
		if (this._closeSubscription) {
			this._closeSubscription.unsubscribe();
		}
	}

	/**
	 * submit form on dialog
	 */
	submit() {
		const {data, dialogRef} = this;
		const {form}            = data;

		if (form.dirty) {
			console.log('dirty');
			if (form.invalid) {
				console.log('form invalid');
				form.focus();
			} else {
				this._submitted = true;
				if (data.onSubmit) {
					console.debug('data.onSubmit');
					data.onSubmit(dialogRef, form.value);
				} else {
					console.debug('this.onSubmit');
					this.onSubmit(form.value);
				}
			}
		} else if (data.onClean) {
			console.log('clean method');
			data.onClean(dialogRef);
		} else {
			console.log('clean');
			dialogRef.close();
		}
	}

	onSubmit(values) {
		throw new Error('`onSubmit` 함수를 구현 해야 합니다.');
	}
}
